module.exports = __webpack_public_path__ + "static/wonderlust-a0a66cbe84318c06be31c1bcb250adb3.png";